import React from 'react';
import { Button, List, Modal, Progress } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { FcCancel } from 'react-icons/fc';
import { UploadProgress } from '../../../hooks/useMapPortalFileUpload';
import './UploadProgressModal.scss';

interface UploadProgressModalProps {
  uploadProgress: UploadProgress | number;
  onCancel?: () => void;
}

const UploadProgressModal: React.FC<UploadProgressModalProps> = ({ uploadProgress, onCancel }) => {
  // The hook resets uploadProgress to 0 when idle; only the per-file map opens the modal.
  const progressByFile = typeof uploadProgress === 'object' ? uploadProgress : {};

  const fileIds = Object.keys(progressByFile);
  const completed = Object.values(progressByFile).filter((progress) => progress === 100).length;

  return (
    <Modal
      open={fileIds.length > 0}
      closable={false}
      maskClosable={false}
      destroyOnClose
      footer={
        onCancel ? (
          <Button danger className="upload-progress__cancel-btn" onClick={onCancel}>
            Cancel Upload
          </Button>
        ) : null
      }
      className="progress-modal"
    >
      <List
        header={<div className="upload-progress__header">{`Upload Queue: ${completed}/${fileIds.length} Complete`}</div>}
        itemLayout="horizontal"
        dataSource={fileIds}
        renderItem={(fileId) => {
          const percent = progressByFile[fileId] || 0;
          const isDone = percent === 100;
          return (
            <List.Item className="upload-progress__item">
              <div className="upload-progress__row">
                <div className="upload-progress__info">
                  <div className="upload-progress__meta">
                    <div className="upload-progress__title">File ID: {fileId}</div>
                    <div className="upload-progress__desc">Progress: {percent}%</div>
                  </div>
                  {isDone ? <CheckCircleOutlined className="upload-progress__check" /> : <FcCancel className="upload-progress__cancel" />}
                </div>
                <Progress percent={percent} status={isDone ? 'success' : 'active'} showInfo={false} className="upload-progress__bar" />
              </div>
            </List.Item>
          );
        }}
      />
    </Modal>
  );
};

export default UploadProgressModal;
